"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelizeArray = void 0;
function modelizeArray(items, model) {
    for (let i = 0; i < items.length; i++) {
        if (!(items[i] instanceof model)) {
            items[i] = new model(items[i]);
        }
    }
    return items;
}
exports.modelizeArray = modelizeArray;
exports.default = modelizeArray;
